<script setup lang="ts"></script>

<template>
  <div class="error-container">
    <slot />
  </div>
</template>

<style scoped>
.error-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-block-size: 100%;
  gap: 4rem;
}
</style>
